/**
 * cc-fundraiser.js  v3
 * CoinCoffee Fundraiser Widget — rebuilt for approved design v3
 *
 * Data sources:
 *   Campaigns table  — Impact Fund Active, Impact Fund Expiry, Campaign End Date
 *   Line Items table — Partner Payout (raised), Order IDs (supporter count),
 *                      Customer Names (avatars), Qty (bags)
 *
 * Supporter count: unique Order IDs only, excluding INV- records.
 */

(function () {
  if (window.__ccFundraiserInit) return;
  window.__ccFundraiserInit = true;

  // ── Config ───────────────────────────────────────────────────────
  var PAT           = 'patFyg873MmYCxtYr.677a041a99d999fc0c3d5e2a907433b66869b254742b5129c9aaf496b88760ba';
  var BASE          = 'appcHQJ5DNxgD2rqp';
  var LINEITEMS_TID = 'tblg3iPZ9IkjI3kyn';
  var CAMPAIGNS_TID = 'tblXaYBbuJfQa9pbl';

  var AVATAR_COLORS = ['#1A5C38', '#0E1311', '#B8934A', '#5C3A1A'];

  // ── Airtable helpers ─────────────────────────────────────────────
  function atGet(tid, params) {
    var url = 'https://api.airtable.com/v0/' + BASE + '/' + tid + '?' + params;
    return fetch(url, { headers: { Authorization: 'Bearer ' + PAT } })
      .then(function (r) {
        if (!r.ok) throw new Error('Airtable ' + r.status);
        return r.json();
      });
  }

  function fetchCampaign(campaignName) {
    var safe = campaignName.replace(/"/g, '\\"');
    var p = new URLSearchParams({
      filterByFormula: 'FIND("' + safe + '", {Campaign Name})>0',
      maxRecords: '1'
    });
    ['Campaign Name', 'Impact Fund Active', 'Impact Fund Expiry', 'Campaign End Date'].forEach(function (f) {
      p.append('fields[]', f);
    });
    return atGet(CAMPAIGNS_TID, p).then(function (data) {
      var rec = (data.records || [])[0];
      return rec ? rec.fields : {};
    });
  }

  function fetchLineItems(campaignName) {
    var safe = campaignName.replace(/"/g, '\\"');
    var filter = 'FIND("' + safe + '", ARRAYJOIN({Campaign}))>0';
    var records = [];

    function page(offset) {
      var p = new URLSearchParams({ filterByFormula: filter, pageSize: '100' });
      ['Order ID', 'Customer Name', 'Qty', 'Partner Payout'].forEach(function (f) { p.append('fields[]', f); });
      if (offset) p.set('offset', offset);
      return atGet(LINEITEMS_TID, p).then(function (data) {
        records = records.concat(data.records || []);
        return data.offset ? page(data.offset) : records;
      });
    }

    return page(null);
  }

  // ── Stats ────────────────────────────────────────────────────────
  function computeStats(records) {
    var orderIds  = new Set();
    var names     = [];
    var seenNames = new Set();
    var payout    = 0;
    var bags      = 0;

    records.forEach(function (r) {
      var f   = r.fields;
      var oid = f['Order ID'];
      if (oid && !oid.startsWith('INV-')) orderIds.add(oid);

      var name = (f['Customer Name'] || '').trim();
      if (name && !seenNames.has(name) && names.length < 4) {
        seenNames.add(name);
        names.push(name);
      }

      payout += Number(f['Partner Payout'] || 0);
      bags   += Number(f.Qty || 0);
    });

    return {
      supporterCount:  orderIds.size,
      recentCustomers: names,
      totalPayout:     payout,
      totalBags:       bags
    };
  }

  // ── Helpers ──────────────────────────────────────────────────────
  function initials(name) {
    var parts = name.trim().split(/\s+/);
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }

  function fmtDollars(n) {
    return '$' + Math.round(n).toLocaleString('en-US');
  }

  function fmtDate(dateStr) {
    var d = new Date(dateStr);
    return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
  }

  function pad(n) {
    return String(Math.max(0, Math.floor(n))).padStart(2, '0');
  }

  // ── Render: tracker ──────────────────────────────────────────────
  function renderTracker(el, campaign, stats) {
    var goal         = parseFloat(el.dataset.goal) || 0;
    var matchedRate  = parseFloat(el.dataset.matchedRate) || 10;
    var pct          = goal > 0 ? Math.min((stats.totalPayout / goal) * 100, 100) : 0;
    var impactActive = !!campaign['Impact Fund Active'];
    var impactExpiry = campaign['Impact Fund Expiry'] || null;
    var endDate      = campaign['Campaign End Date']  || null;
    var cdTarget     = impactActive && impactExpiry ? impactExpiry : endDate;

    // 1 ── Impact Fund Banner
    var banner = el.querySelector('[data-cc-impact-banner]');
    if (banner) {
      if (impactActive && cdTarget) {
        banner.style.display = '';

        var labelEl = banner.querySelector('[data-cc-banner-label]');
        if (labelEl) {
          labelEl.textContent = 'CoinCoffee matches every bag \u2014 ends ' + fmtDate(impactExpiry || cdTarget);
        }

        var dEl = banner.querySelector('[data-cc-d]');
        var hEl = banner.querySelector('[data-cc-h]');
        var mEl = banner.querySelector('[data-cc-m]');

        function updateCountdown() {
          var diff = Math.max(0, new Date(cdTarget) - new Date());
          if (dEl) dEl.textContent = pad(diff / 86400000);
          if (hEl) hEl.textContent = pad((diff % 86400000) / 3600000);
          if (mEl) mEl.textContent = pad((diff % 3600000) / 60000);
        }

        if (window._ccTimer) clearInterval(window._ccTimer);
        updateCountdown();
        window._ccTimer = setInterval(updateCountdown, 1000);

      } else {
        banner.style.display = 'none';
      }
    }

    // 2 ── Amount raised
    var raisedEl = el.querySelector('[data-cc-raised]');
    if (raisedEl) raisedEl.textContent = fmtDollars(stats.totalPayout);

    // 3 ── Progress bar
    var fillEl = el.querySelector('[data-cc-fill]');
    if (fillEl && goal > 0) {
      setTimeout(function () { fillEl.style.width = pct.toFixed(1) + '%'; }, 150);
    }

    // 4 ── Meta row
    var pctEl = el.querySelector('[data-cc-pct]');
    if (pctEl) pctEl.textContent = Math.round(pct) + '% complete';

    var bagsEl = el.querySelector('[data-cc-bags]');
    if (bagsEl) bagsEl.textContent = stats.totalBags.toLocaleString('en-US');

    var matchedEl = el.querySelector('[data-cc-matched]');
    if (matchedEl) matchedEl.textContent = fmtDollars(stats.totalPayout) + ' raised \u2713';

    // 5 ── Social proof avatars
    var avatarEl = el.querySelector('[data-cc-avatars]');
    if (avatarEl && stats.recentCustomers.length > 0) {
      var html = stats.recentCustomers.map(function (name, i) {
        return '<div class="av" style="background:' + AVATAR_COLORS[i % AVATAR_COLORS.length] + '">'
          + initials(name) + '</div>';
      }).join('');
      var overflow = stats.supporterCount - stats.recentCustomers.length;
      if (overflow > 0) {
        html += '<div class="av" style="background:rgba(0,0,0,.18);color:#2C2520;font-size:9px">+' + overflow + '</div>';
      }
      avatarEl.innerHTML = html;
    }

    // 6 ── Social proof text
    var spSupportersEl = el.querySelector('[data-cc-sp-supporters]');
    if (spSupportersEl) spSupportersEl.textContent = stats.supporterCount.toLocaleString('en-US');

    var spSubEl = el.querySelector('[data-cc-sp-sub]');
    if (spSubEl) {
      if (impactActive) {
        spSubEl.innerHTML = ' unlocked <span class="g">' + fmtDollars(stats.totalPayout)
          + ' in matched giving</span> \u2014 every bag doubles the impact.';
      } else {
        spSubEl.textContent = ' supporters have already purchased \u2014 every bag makes a difference.';
      }
    }

    // 7 ── Show content, hide loader
    var loadEl    = el.querySelector('[data-cc-loading]');
    var contentEl = el.querySelector('[data-cc-content]');
    if (loadEl)    loadEl.style.display    = 'none';
    if (contentEl) contentEl.style.display = '';
  }

  // ── Error state ──────────────────────────────────────────────────
  function renderError(el) {
    var loadEl = el.querySelector('[data-cc-loading]');
    var errEl  = el.querySelector('[data-cc-error]');
    if (loadEl) loadEl.style.display = 'none';
    if (errEl)  { errEl.textContent = 'Live data unavailable'; errEl.style.display = ''; }
  }

  // ── Init ─────────────────────────────────────────────────────────
  function init() {
    var trackers = document.querySelectorAll('[data-cc-tracker]');

    var trackerMap = {};
    Array.prototype.forEach.call(trackers, function (el) {
      var name = (el.dataset.campaign || '').trim();
      if (!name) return;
      if (!trackerMap[name]) trackerMap[name] = [];
      trackerMap[name].push(el);
    });

    Object.keys(trackerMap).forEach(function (campaignName) {
      var elements = trackerMap[campaignName];
      Promise.all([fetchCampaign(campaignName), fetchLineItems(campaignName)])
        .then(function (results) {
          var stats = computeStats(results[1]);
          elements.forEach(function (el) { renderTracker(el, results[0], stats); });
        })
        .catch(function () { elements.forEach(renderError); });
    });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
